import React, {
  useEffect,
} from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const navigate = useNavigate();

  const location = useLocation();


  const {
    restaurantId,
    tableId,
  } = useParams();


  const {
    orderId,
    orderNumber,
    paymentMethod,
    total,
    paymentId,
  } = location.state || {};


  // =====================================================
  // HOME PATH
  // =====================================================

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  // =====================================================
  // AUTO REDIRECT
  // =====================================================

  useEffect(() => {

    const timer =
      setTimeout(() => {

        navigate(
          homePath,
          {
            replace: true,
          }
        );

      }, 10000);


    return () => {

      clearTimeout(timer);

    };

  }, [
    navigate,
    homePath,
  ]);


  // =====================================================
  // FORMAT PRICE
  // =====================================================

  const formattedTotal =
    Number(
      total || 0
    ).toFixed(2);


  // =====================================================
  // PAYMENT LABEL
  // =====================================================

  const paymentLabel =
    paymentMethod === "ONLINE"
      ? "Online Payment"
      : "Pay at Table";


  return (

    <main className="t7-success-page">


      {/* =================================================
          SUCCESS HERO
      ================================================= */}

      <section className="t7-success-main">

        <div className="t7-success-card">


          {/* =================================================
              CHECK ICON
          ================================================= */}

          <div className="t7-success-icon">

            <span>
              ✓
            </span>

          </div>


          <span className="t7-success-label">
            ORDER CONFIRMED
          </span>


          <h1>
            Thank You
          </h1>


          <p className="t7-success-message">

            Your order has been received
            and is being prepared fresh
            for your table.

          </p>



          {/* =================================================
              ORDER NUMBER
          ================================================= */}

          <div className="t7-success-order">

            <span>
              ORDER
            </span>


            <strong>
              {orderNumber ||
                `#${orderId || "—"}`}
            </strong>

          </div>



          {/* =================================================
              ORDER INFO
          ================================================= */}

          <div className="t7-success-details">


            <div className="t7-success-detail">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>


            <div className="t7-success-detail">

              <span>
                PAYMENT
              </span>

              <strong>
                {paymentLabel}
              </strong>

            </div>


            <div className="t7-success-detail">

              <span>
                TOTAL
              </span>

              <strong>
                ₹
                {formattedTotal}
              </strong>

            </div>

          </div>



          {/* =================================================
              ONLINE PAYMENT ID
          ================================================= */}

          {paymentMethod === "ONLINE" &&
            paymentId && (

              <div className="t7-payment-id">

                <span>
                  PAYMENT ID
                </span>

                <strong>
                  {paymentId}
                </strong>

              </div>

            )}



          {/* =================================================
              CASH MESSAGE
          ================================================= */}

          {paymentMethod === "CASH" && (

            <div className="t7-cash-message">

              <span>
                ₹
              </span>

              <p>
                Please keep your payment ready.
                You can pay at the table when
                your order is served.
              </p>

            </div>

          )}



          {/* =================================================
              HOME BUTTON
          ================================================= */}

          <button
            type="button"
            className="t7-success-home-button"
            onClick={() =>
              navigate(
                homePath,
                {
                  replace: true,
                }
              )
            }
          >

            Back to Menu

            <span>
              →
            </span>

          </button>


          <p className="t7-success-redirect">

            You will be returned to the menu
            automatically in a few seconds.

          </p>

        </div>

      </section>



      {/* =================================================
          BRAND FOOTER
      ================================================= */}

      <footer className="t7-success-footer">

        <div className="t7-success-footer-brand">

          <span>
            SPICE &amp; SAFFRON
          </span>

          <small>
            INDIAN CUISINE
          </small>

        </div>


        <p>
          Authentic flavours · Fresh ingredients ·
          Memorable experiences
        </p>

      </footer>

    </main>

  );

}


export default SuccessScreen;